<template>
  <v-container class="grey lighten-5 mb-6" fluid>
    <v-row>
      <v-col>
        <v-card class="mx-auto form-card-padding">
          <v-toolbar flat>
            <v-toolbar-title class="grey--text">
              {{ $t('vendor.edit.title') }}
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn icon>
              <v-icon>mdi-account-plus</v-icon>
            </v-btn>
          </v-toolbar>

          <v-divider></v-divider>

          <v-form ref="userForm" lazy-validation>
            <v-text-field
              v-model="vendor.name"
              :counter="255"
              :rules="validation.nameRules"
              :label="$t('vendor.edit.name')"
              required
            ></v-text-field>

            <v-text-field
              v-model="vendor.adress"
              :counter="255"
              :rules="validation.adress"
              :label="$t('vendor.edit.adress')"
              required
            ></v-text-field>


            <v-text-field
              v-model="vendor.email"
              :counter="255"
              :rules="validation.email"
              :label="$t('vendor.edit.email')"
              required
            ></v-text-field>


            <v-text-field
              v-model="vendor.telephone"
              :counter="255"
              :rules="validation.telephone"
              :label="$t('vendor.edit.phone')"
              required
            ></v-text-field>

            <v-autocomplete
              style="margin-top: 10px"
              v-model="vendor.countries"
              :items="countries"
              dense
              filled
              :label="$t('vendor.edit.countries')"
              multiple
              item-value="id"
              item-text="nicename"
            ></v-autocomplete>

            <v-btn
              color="success"
              class="mr-4 align-self-lg-end"
              @click="updateVendor()"
            >
            {{ $t('vendor.edit.controlls.update') }}
            </v-btn>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <error-handler :error="error"></error-handler>
  </v-container>
</template>
<script>
export default {
  name: "EditVednor",
  data() {
    return {
      error: null,
      isLoading: true,
      validation: {
        name: [
          (v) => !!v || "Name is required",
          (v) =>
            (v && v.length <= 255) || "Name must be less than 255 characters",
        ],
        adress: [
          (v) => !!v || "Adress is required",
          (v) =>
            (v && v.length <= 255) || "Adress must be less than 255 characters",
        ],
        telephone: [
          (v) => !!v || "Telephone is required",
          (v) =>
            (v && v.length <= 255) || "Telephone must be less than 255 characters",
        ],
        email: [
          (v) => !!v || "E-mail is required",
          (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
        ],
      },
      vendor: {
        name: "",
        adress: "",
        email: "",
        telephone: "",
        countries: null,
      },
    };
  },
  computed: {
    applicationData() {
      return this.$store.state.applicationData
    },
    countries() {
      if(this.applicationData) {
        return this.applicationData.countries; 
      }
      return []
    }
  },
  mounted() {
    this.$store.dispatch("loadApplicationData")
    this.getVendor();
  },
  methods: {
    updateVendor() {
      this.$axios({
        method: "post",
        url: this.$globals.api.vendors.update + this.$route.params.id,
        data: this.vendor,
      })
        .then(() => {
          this.$router.push({ name: "vendor/list" });
        })
        .catch((error) => {
          this.error = error.response;
        });
    },

    getVendor() {
      this.$axios({
        method: "get",
        url: this.$globals.api.vendors.get + this.$route.params.id,
      })
        .then((response) => {
          this.vendor.name = response.data.data.name;
          this.vendor.adress = response.data.data.adress;
          this.vendor.email = response.data.data.email;
          this.vendor.telephone = response.data.data.telephone;
          this.vendor.countries = response.data.data.countries;
        })
        .catch((error) => {
          this.error = error.response;
        });
    },
  },
};
</script>